module.exports = __webpack_public_path__ + "img/asset-02.15f10191.svg";